import React from "react"
import styled from "styled-components"

const SVGContainer = styled.div`
  cursor: pointer;
  height: 3rem;
  display: flex;
  align-items: center;
  border-radius: 10rem;
  background: #fff;
  justify-content: center;
  color: #6b6c6d;
`

export const Facebook = () => {
    return (
        <a href="https://www.facebook.com/AceHardwarePhilippines/">
            <SVGContainer>
                <svg
                    style={{
                        fill: "currentColor",
                        width: "2.5rem",
                        height: "2.5rem",
                    }}
                    viewBox="0 0 24 24"
                >
                    <path d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" />
                </svg>
            </SVGContainer>
        </a>
    )
}

export const Twitter = () => {
    return (
        <a href="https://twitter.com/thesmstore">
            <SVGContainer>
                <svg
                    style={{
                        fill: "currentColor",
                        width: "3rem",
                        height: "2rem",
                    }}
                    viewBox="0 0 24 24"
                >
                    <path d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />
                </svg>
            </SVGContainer>
        </a>
    )
}

export const Instagram = () => {
    return (
        <a href="https://www.instagram.com/acehardware_ph/">
            <SVGContainer>
                <svg
                    style={{
                        fill: "currentColor",
                        width: "2.5rem",
                        height: "2.5rem",
                    }}
                    viewBox="0 0 24 24"
                >
                    <path d="M20,6.5A0.5,0.5 0 0,1 19.5,7H17.5A0.5,0.5 0 0,1 17,6.5V4.5A0.5,0.5 0 0,1 17.5,4H19.5A0.5,0.5 0 0,1 20,4.5M4.5,20A0.5,0.5 0 0,1 4,19.5V11H6.09C6.03,11.32 6,11.66 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12C18,11.66 17.96,11.32 17.91,11H20V19.5A0.5,0.5 0 0,1 19.5,20M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M20,2H4C2.89,2 2,2.89 2,4V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V4C22,2.89 21.1,2 20,2Z" />
                </svg>
            </SVGContainer>
        </a>
    )
}

export const Youtube = () => {
    return (
        <a href="https://www.youtube.com/channel/UCf3ae5buKgLYkZKzlWEdieQ">
            <SVGContainer>
                <svg
                    style={{
                        fill: "currentColor",
                        width: "3rem",
                        height: "2rem",
                    }}
                    viewBox="0 0 24 24"
                >
                    <path d="M10,16.5V7.5L16,12M20,4.4C19.4,4.2 15.7,4 12,4C8.3,4 4.6,4.19 4,4.38C2.44,4.9 2,8.4 2,12C2,15.59 2.44,19.1 4,19.61C4.6,19.81 8.3,20 12,20C15.7,20 19.4,19.81 20,19.61C21.56,19.1 22,15.59 22,12C22,8.4 21.56,4.91 20,4.4Z" />
                </svg>
            </SVGContainer>
        </a>
    )
}
